import { db } from '../utils/firebase';

export const getAdministration = async () => {
  const querySnapshot = db.collection("administration").doc("page");
  const doc = await querySnapshot.get();
  const { content } = doc.data();

  return content;
};

